import { motion } from 'framer-motion';
import SkillBadges from './SkillBadges';

export default function TimelineColumn({ data }) {
  return (
    <div className="timeline">
      <motion.h3
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="timeline__heading"
      >
        {data.heading}
      </motion.h3>
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.2, duration: 0.6 }}
        className="timeline__subheading"
      >
        {data.subheading}
      </motion.div>
      {data.items.map((item, i) => (
        <motion.div
          key={item.title}
          className="timeline__item"
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3 + i * 0.1, duration: 0.6 }}
        >
          <div className="timeline__year">{item.year}</div>
          <div className="timeline__card">
            <div className="timeline__item-title">{item.title}</div>
            <div className="timeline__item-desc">{item.description}</div>
          </div>
        </motion.div>
      ))}
      <SkillBadges skills={data.skills} />
    </div>
  );
}
